<template>
  <div id="dashboard" class="fixWidth container-fluid" tag="section">
    <v-row>
      <v-col cols="12" sm="6" lg="6">
        <base-material-stats-card
          color="info"
          icon="mdi-school"
          title="Faculty"
          :value="getfacilityDashboardItem.total_teacher"
        />
      </v-col>

      <v-col cols="12" sm="6" lg="6">
        <base-material-stats-card
          color="primary"
          icon="mdi-domain"
          title="Departments"
          :value="getfacilityDashboardItem.total_department"
        />
      </v-col>

      <v-col cols="12" sm="6" lg="6">
        <base-material-stats-card
          color="success"
          icon="mdi-book"
          title="Total Subject"
          :value="getfacilityDashboardItem.total_subject"
        />
      </v-col>

      <v-col cols="12" sm="6" lg="6">
        <base-material-stats-card
          color="orange"
          icon="mdi-account-group"
          title="Total Batch"
          :value="getfacilityDashboardItem.total_batch"
        />
      </v-col>
      <!-- {{ getfacilityDashboardItem }} -->
      <v-row>
        <v-col cols="12">
          <v-col cols="12">
            <v-tabs>
              <v-tab @click="tabView(1)">Daily Attendance</v-tab>
              <v-tab @click="tabView(2)">Weekly Attendance</v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="12" v-if="showTab == 1">
            <GChart
              type="ColumnChart"
              :data="dailyAttendanceData"
              :options="chartOptions.chart"
            />
          </v-col>
          <v-col cols="12" v-if="showTab == 2">
            <GChart
              type="LineChart"
              :data="weeklyAttendanceData"
              :options="chartOptions.chart"
            />
          </v-col>
        </v-col>
      </v-row>
      
      <v-col cols="12">
        <h3>Academic Calender</h3>
      </v-col>
      <v-col cols="12">
        <v-sheet height="64">
          <v-toolbar flat>
            <v-btn
              outlined
              class="mr-4"
              color="grey darken-2"
              @click="setToday"
            >
              Today
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="prev">
              <v-icon small> mdi-chevron-left </v-icon>
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="next">
              <v-icon small> mdi-chevron-right </v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right> mdi-menu-down </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>Day</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>Week</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>Month</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = '4day'">
                  <v-list-item-title>4 days</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-sheet>
        <v-sheet height="600">
          <v-calendar
            ref="calendar"
            v-model="focus"
            color="primary"
            :events="getfacilityDashboardItem.academic_calender"
            
            :event-color="getEventColor"
            :type="type"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @change="updateRange"
          ></v-calendar>
          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
          >
            <v-card color="grey lighten-4" min-width="350px" flat>
              <v-toolbar :color="selectedEvent.color" dark>
                <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <span v-html="selectedEvent.details"></span>
              </v-card-text>
              <v-card-text>
                 <p> <b> Description:</b> </p>
                <span v-html="selectedEvent.description"></span>
              </v-card-text>
               <v-card-text>
                 <p> <b> Category: </b></p>
                <span v-html="selectedEvent.category"></span>
              </v-card-text>
               <v-card-text>
                 <p> <b> Place: </b></p>
                <span v-html="selectedEvent.event_place"></span>
              </v-card-text>
               <v-card-text>
                 <p> <b> Start Time: </b></p>
                <span v-html="selectedEvent.start"></span>
              </v-card-text>
               <v-card-text>
                 <p> <b> End Time: </b></p>
                <span v-html="selectedEvent.end"></span>
              </v-card-text>
              <v-card-actions>
                <v-btn text color="secondary" @click="selectedOpen = false">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row> </v-row>
  </div>
</template>


<script>
import { GChart } from "vue-google-charts";
import functionalMixin from "../../mixins/searchFunction";

export default {
  name: "DashboardDashboard",
  components: {
    GChart,
  },
  mixins: [
    functionalMixin
  ],
  data() {
    return {
      showTab: 1,
      chartData: [
        ["Subjects", "Present", "Total", "Absent"],
        ["Anatomy", 400,1000, 200],
        ["Physiology",460, 1170, 250],
        ["Biochemistry", 1120 , 660, 300],
        ["Pathology", 540,1030, 350],
        ["Microbiology",540 , 1030, 350],
        ["Pharmacology and Therapeutic", 540, 1030, 350],
      ],
      chartOptions: {
        chart: {
          // title: "Company Performance",
          // subtitle: "Sales, Expenses, and Profit: 2014-2017",
          width: 1100,
          height: 600,
          colors: ["green", "blue", "orange"],
        },
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      colors: [
        "blue",
        "indigo",
        "deep-purple",
        "cyan",
        "green",
        "orange",
        "grey darken-1",
      ],
      names: [
        "Meeting",
        "Holiday",
        "PTO",
        "Travel",
        "Event",
        "Birthday",
        "Conference",
        "Party",
      ],

      value: [200, 675, 410, 390, 310, 460, 250],

      dailySalesChart: {
        data: {
          labels: ["M", "T", "W", "T", "F", "S", "S"],
          series: [[12, 17, 7, 17, 23, 18, 38]],
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0,
          }),
          low: 0,
          high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
      },
      dataCompletedTasksChart: {
        data: {
          labels: ["12am", "3pm", "6pm", "9pm", "12pm", "3am", "6am", "9am"],
          series: [[230, 750, 450, 300, 280, 240, 200, 190]],
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0,
          }),
          low: 0,
          high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
      },
      emailsSubscriptionChart: {
        data: {
          labels: [
            "Ja",
            "Fe",
            "Ma",
            "Ap",
            "Mai",
            "Ju",
            "Jul",
            "Au",
            "Se",
            "Oc",
            "No",
            "De",
          ],
          series: [
            [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
          ],
        },
        options: {
          axisX: {
            showGrid: false,
          },
          low: 0,
          high: 1000,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0,
          },
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function (value) {
                  return value[0];
                },
              },
            },
          ],
        ],
      },

      list: {
        0: false,
        1: false,
        2: false,
      },
    };
  },
    created() {
      let guard = localStorage.getItem("dgmeGuard");
      
      if ( guard == "false")
      {
        this.$router.push("/");
      }
  },
  mounted() {
    this.$refs.calendar.checkChange();
    this.$store.dispatch("callfacilityDashboardData");
  },
  methods: {
    complete(index) {
      this.list[index] = !this.list[index];
    },
    tabView(tab) {
      this.showTab = tab;
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      const events = [];

      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0;
        const firstTimestamp = this.rnd(min.getTime(), max.getTime());
        const first = new Date(firstTimestamp - (firstTimestamp % 900000));
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
        const second = new Date(first.getTime() + secondTimestamp);

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        });
      }

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
  },
  computed: {
    getfacilityDashboardItem() {
      return this.$store.getters.getfacilityDashboardItem;
    },
   
    dailyAttendanceData() {
      let temp = this.$store.getters.getfacilityDashboardItem;
      if(temp.daily_attendance){
        if(temp.daily_attendance.length > 1){
          for(let i=1;i<temp.daily_attendance.length;i++){
          for(let j=1;j<temp.daily_attendance[i].length;j++){
            temp.daily_attendance[i][j] = Number(temp.daily_attendance[i][j]);
          }
        }
        
        }
        else{
          temp.daily_attendance.push(
            ["No Data found",0,0,0]
          )
        }
        return temp.daily_attendance;
      } else {
        return temp;
      }
    },
    weeklyAttendanceData(){
      let temp = this.$store.getters.getfacilityDashboardItem;
      if(temp.weekly_attendance){
        if(temp.weekly_attendance.length > 1){
          for(let i=1;i<temp.weekly_attendance.length;i++){
          for(let j=1;j<temp.weekly_attendance[i].length;j++){
            temp.weekly_attendance[i][j] = (temp.weekly_attendance[i][j]);
          }
        }
        
        }
        else{
          temp.weekly_attendance.push(
            ["No Data found",0,0,0]
          )
        }
        return temp.weekly_attendance;
      }
      else{
        return temp;
      }
    },
  },
};
</script>
<style>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined), .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover{
  color: black;
  font-weight: bolder;
}
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
  margin-right: 0px;
}
</style>